import React from "react";
import { WSButton, WSText } from "@wingspanhq/fe-component-library";
import {
  ICollaboratorSchema,
  IMemberClient
} from "@wingspanhq/payments/dist/interfaces";

import { getClientCompanyName, getClientEmail } from "../../../utils/client";
import { getCurrentYearForm1099Balances } from "../../../query/payments/selectors";
import getTotalsItems from "../../utils/getTotalsItems";
import LabelValueList, {
  ListValueType
} from "../../../components/LabelValueList";
import {
  getCollaboratorCompanyName,
  getCollaboratorEmail
} from "../../../utils/collaborator";
import { SidePanelSection } from "../../../components/SidePanel";

export enum NECSummaryDataType {
  Client = "Client",
  Collaborator = "Collaborator"
}

const infoLines = [
  `This is just a summary of the information that will appear on your 1099-NEC form and should not be treated as an official record. If there is an error with your TIN, address, or delivery method, update them in your settings.`,

  `This is NOT the final 1099-NEC and must not be used to calculate your tax liability.`
];

interface ContentProps {
  data: IMemberClient | ICollaboratorSchema;
  type: NECSummaryDataType;
}

const Content: React.FC<ContentProps> = ({ type, data }) => {
  const companyName =
    type === NECSummaryDataType.Client
      ? getClientCompanyName(data as IMemberClient)
      : getCollaboratorCompanyName(data as ICollaboratorSchema);
  const clientEmail =
    type === NECSummaryDataType.Client
      ? getClientEmail(data as IMemberClient)
      : getCollaboratorEmail(data as ICollaboratorSchema);
  const currentForm1099Balances = getCurrentYearForm1099Balances(data);

  const payerInfoItems = [
    {
      label: "Name",
      value: companyName || "-"
    },
    {
      label: "Phone",
      // TODO(@Anesh): Where should we access phone number?
      value: "?"
    },
    {
      label: "Email address",
      value: clientEmail || "-"
    }
  ].map(item => ({ ...item, id: item.label, type: ListValueType.Text }));

  return (
    <>
      <SidePanelSection title={companyName} first>
        <LabelValueList
          items={
            currentForm1099Balances && getTotalsItems(currentForm1099Balances)
          }
        />
      </SidePanelSection>

      <SidePanelSection title="Payer information">
        <LabelValueList items={payerInfoItems} />
      </SidePanelSection>

      <SidePanelSection>
        <WSButton.Tertiary fullWidth onClick={() => {}}>
          See payments
        </WSButton.Tertiary>

        <WSButton.Secondary fullWidth mt="M" onClick={() => {}}>
          Suggest change
        </WSButton.Secondary>

        <WSButton.Primary fullWidth mt="M" onClick={() => {}}>
          Approve draft summary
        </WSButton.Primary>

        {infoLines.map(line => (
          <WSText key={line.substring(0, 40)} mt="M" color="grey600">
            {line}
          </WSText>
        ))}
      </SidePanelSection>
    </>
  );
};

export default Content;
